import * as React from "react";
import * as lottie from "lottie-web";

interface LoaderProps {
  animationData: any;
  isVisible?: boolean;
  speed?: number;
  loop?: boolean;
  autoplay?: boolean;
  startIndex?: number;
}

const Loader: React.FC<LoaderProps> = ({
  animationData,
  isVisible,
  speed,
  loop,
  autoplay,
  startIndex,
}: LoaderProps) => {
  let loaderWrapper: any = null;

  React.useEffect(() => {
    const animData = {
      wrapper: loaderWrapper,
      animType: "svg",
      loop,
      prerender: true,
      autoplay,
      animationData,
    };
    // @ts-ignore
    const anim = lottie.loadAnimation(animData);
    anim.setSpeed(speed || 1);

    anim.goToAndPlay(startIndex);

    return function cleanup() {
      anim.destroy();
    };
  }, [animationData, autoplay, loaderWrapper, loop, speed, startIndex]);

  if (!isVisible) return null;

  // eslint-disable-next-line no-return-assign
  return <div ref={(image) => (loaderWrapper = image)} id="loader" />;
};

Loader.defaultProps = {
  isVisible: true,
  speed: 1,
  loop: true,
  autoplay: true,
  startIndex: 0,
};

export default Loader;
